import api from '../services/api';

const getNomeModulo = (modulo) => {
  if (typeof modulo === 'string') return modulo;
  return modulo?.nome || modulo?.st_nome;
};
const getDescricaoModulo = (modulo) => modulo?.descricao || modulo?.st_descricao || getNomeModulo(modulo);
const getIconeModulo = (modulo) => modulo?.icone || modulo?.st_icone;

const montarRotas = (modulos) => {
  const modulosUnicos = new Map();

  modulos.forEach((mod) => {
    try {
      const nomeModulo = getNomeModulo(mod);
      const descricaoModulo = getDescricaoModulo(mod);

      if (!nomeModulo || !descricaoModulo || modulosUnicos.has(nomeModulo)) {
        return;
      }

      try {
        const modulo = require(`../modules/${nomeModulo}/index.jsx`).default;

        if (modulo) {
          modulosUnicos.set(nomeModulo, {
            path: `/${nomeModulo}`,
            element: modulo,
            nome: descricaoModulo,
            icone: getIconeModulo(mod)
          });
        }
      } catch (err) {
        console.warn(`Módulo ${nomeModulo} não encontrado:`, err.message);
      }
    } catch (err) {
      console.warn(`Erro ao processar módulo ${getNomeModulo(mod) || 'desconhecido'}:`, err);
    }
  });

  const rotas = Array.from(modulosUnicos.values());
  const rotasEstaticas = [];

  if (modulosUnicos.has('usuarios')) {
    try {
      const Profiles = require('../modules/profiles/index.jsx').default;
      rotasEstaticas.push({
        path: '/profiles',
        element: Profiles,
        nome: 'Perfis',
        icone: 'AdminPanelSettings'
      });
    } catch (err) {
      console.warn('Módulo profiles não encontrado:', err.message);
    }
  }

  return [...rotas, ...rotasEstaticas];
};

export async function carregarModulosDisponiveis(usuario) {
  if (!usuario) {
    console.warn('Usuário não fornecido para carregar módulos');
    return [];
  }

  try {
    const response = await api.get('/session');
    const usuarioAtualizado = response.data?.usuario;
    const tokenAtualizado = response.data?.token;

    if (!usuarioAtualizado) {
      return [];
    }

    const modulos = Array.isArray(usuarioAtualizado.modulos) ? usuarioAtualizado.modulos : [];
    if (tokenAtualizado) {
      localStorage.setItem("token", tokenAtualizado);
    }
    localStorage.setItem("usuario", JSON.stringify(usuarioAtualizado));
    localStorage.setItem("modulos", JSON.stringify(modulos));

    return montarRotas(modulos);
  } catch (err) {
    console.error('Erro ao carregar módulos:', err);
    console.error('Detalhes do erro:', {
      message: err.message,
      response: err.response?.data,
      status: err.response?.status
    });

    localStorage.setItem("modulos", JSON.stringify([]));
    return [];
  }
}
